import fetch from '@/util/http'

export default {
  commentPage(params) {
    return fetch.get('comment/page', params)
  },
  commentPost(model) {
    return fetch.post('comment/insert', model)
  }
}



// WEBPACK FOOTER //
// ./src/api/comment.js